<template>
  <div class="daytime-advice-action-bar">
    <slot />
  </div>
</template>
<script>
export default {
  name: "DaytimeAdviceActionBar"
};
</script>
<style lang="scss" scoped>
.daytime-advice-action-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  min-height: 64px; /* DaytimeAdviceSheetSidebar側の高さ計算(calc(100vh - ...))が参照する固定値 */
  border-top: 1px solid #e0e0e0;
  background-color: #fff;
}
</style>
